export var KycDetailsStatusEnum;
(function (KycDetailsStatusEnum) {
    KycDetailsStatusEnum["COMPLETED"] = "COMPLETED";
    KycDetailsStatusEnum["RESET"] = "RESET";
    KycDetailsStatusEnum["PENDING_DOCUMENT_UPLOAD"] = "PENDING_DOCUMENT_UPLOAD";
    KycDetailsStatusEnum["PENDING_QUESTIONNAIRE"] = "PENDING_QUESTIONNAIRE";
    KycDetailsStatusEnum["PENDING_SELFIE_UPLOAD"] = "PENDING_SELFIE_UPLOAD";
    KycDetailsStatusEnum["REJECTED"] = "REJECTED";
    KycDetailsStatusEnum["REJECTED_DUPLICATE_APPLICANT"] = "REJECTED_DUPLICATE_APPLICANT";
})(KycDetailsStatusEnum || (KycDetailsStatusEnum = {}));
//# sourceMappingURL=kyc-details-status.enum.js.map